import { authenticated } from '../../helpers/auth-header';
import insighttAPI from '../clients/insightt-api-client';
import { taskManagementEndpoints } from '../endpoints';

const getAssignerTasks = (branchId, startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(
    taskManagementEndpoints.getAssignerTasksAPI(branchId, startDate, endDate, timezoneOffset),
  );

const createNewTask = (payload) =>
  authenticated(insighttAPI).post(taskManagementEndpoints.createNewTaskAPI(), payload);

const closeTask = (taskId, payload) =>
  authenticated(insighttAPI).post(taskManagementEndpoints.closeTaskAPI(taskId), payload);

const readTask = (taskId) => authenticated(insighttAPI).post(taskManagementEndpoints.readTaskAPI(taskId));

const approveCompleted = (taskId) =>
  authenticated(insighttAPI).post(taskManagementEndpoints.approveCompletedAPI(taskId), {});

const rejectCompleted = (taskId, payload) =>
  authenticated(insighttAPI).post(taskManagementEndpoints.rejectCompletedAPI(taskId), payload);

const approveNewDeadline = (taskId) =>
  authenticated(insighttAPI).post(taskManagementEndpoints.approveNewDeadlineAPI(taskId), {});

const declineNewDeadline = (taskId, payload) =>
  authenticated(insighttAPI).post(taskManagementEndpoints.declineNewDeadlineAPI(taskId), payload);

const getReceiverTasks = (branchId, startDate, endDate, timezoneOffset) =>
  authenticated(insighttAPI).get(
    taskManagementEndpoints.getReceiverTasksAPI(branchId, startDate, endDate, timezoneOffset),
  );

const proposeNewDeadline = (taskId, payload) =>
  authenticated(insighttAPI).post(taskManagementEndpoints.proposeNewDeadlineAPI(taskId), payload);

const cancelNewDeadline = (taskId) =>
  authenticated(insighttAPI).post(taskManagementEndpoints.cancelNewDeadlineAPI(taskId), {});

const markAsCompleted = (taskId) =>
  authenticated(insighttAPI).post(taskManagementEndpoints.markAsCompletedAPI(taskId), {});

const acknowledgeUncompleted = (taskId) =>
  authenticated(insighttAPI).post(taskManagementEndpoints.acknowledgeUncompletedAPI(taskId), {});

export const taskManagementService = {
  getAssignerTasks,
  createNewTask,
  closeTask,
  approveCompleted,
  rejectCompleted,
  approveNewDeadline,
  declineNewDeadline,
  getReceiverTasks,
  proposeNewDeadline,
  cancelNewDeadline,
  markAsCompleted,
  acknowledgeUncompleted,
  readTask,
};
